import { createApp } from 'vue';
import { getVendorConsent, registerConsentListeners } from '../../globals/consentmanager';
import cmpVendorIDs from '../../globals/constants/cmpVendorIDs';
import { getMarketingConsent } from '../../globals/cookiebot';
import initConsentModals from './initConsentModals';

export default function init(pinia) {
  const elements = document.querySelectorAll('.modalOverlay');

  const vendor = cmpVendorIDs.YOUTUBE;

  if (elements.length) {
    elements.forEach((element) => {
      const app = createApp({
        data: function () {
          return {
            isVideo: true,
            modalActive: false,
            htmlElement: null,
            consentGiven:
              window.cmpConsentType === 'cookiebot'
                ? getMarketingConsent()
                : getVendorConsent(vendor.id),
          };
        },
        watch: {
          isModalOpen: function (newValue, oldValue) {
            if (newValue !== oldValue) {
              newValue === true ? this.openModal() : this.closeModal();
            }
          },
          modalActive: function (newValue) {
            this.consentGiven =
              window.cmpConsentType === 'cookiebot'
                ? getMarketingConsent()
                : getVendorConsent(vendor.id);
            this.checkConsent();
            if (newValue) {
              this.$nextTick(() => {
                this.removeCloseClassFromConsentButton();
              });
            }
          },
          consentGiven: function (newValue, oldValue) {
            if (newValue !== oldValue) {
              this.checkConsent();
            }
          },
        },
        mounted() {
          this.checkVendorConsent && registerConsentListeners(this.checkVendorConsent);
          window.addEventListener('keyup', this.escCloseModal);
          this.htmlElement = document.querySelector('html');
        },
        unmounted() {
          window.removeEventListener('keyup', this.escCloseModal);
        },
        methods: {
          handleContentButton() {
            if (window.cmpConsentType == 'consentmanager') {
              if (window.__cmp) {
                window.__cmp('setVendorConsent', [vendor.id, 1], () => {
                  this.consentGiven = getVendorConsent(vendor.id);
                  this.checkConsent();
                });
              }
            } else {
              if (window.Cookiebot) {
                window.Cookiebot.onaccept = () => {
                  this.consentGiven = getMarketingConsent();
                };
              }
              this.checkConsent();
            }
          },
          checkVendorConsent() {
            this.consentGiven = getVendorConsent(vendor.id);
            this.checkConsent();
          },
          removeCloseClassFromConsentButton() {
            if (!this.consentGiven) {
              const consentDiv = this.$refs.modalContent?.querySelector('.Modal__consent');
              if (consentDiv) {
                const consentButton = consentDiv.querySelector('.Modal__consentButton');
                if (consentButton) {
                  const classesToRemove = Array.from(consentButton.classList).filter(
                    (cls) => cls.includes('Button__close') || cls.startsWith('close'),
                  );
                  classesToRemove.forEach((cls) => consentButton.classList.remove(cls));
                }
              }
            }
          },
          checkConsent() {
            const iframe = this.$refs.modalContent?.querySelector('iframe');

            if (iframe && this.isVideo) {
              if (this.consentGiven && this.modalActive) {
                iframe.style.display = 'block';
                if (!iframe.src) {
                  iframe.src = iframe.getAttribute('data-src');
                  iframe.removeAttribute('data-src');
                }
              } else {
                iframe.style.display = 'none';
                if (iframe.src) {
                  iframe.setAttribute('data-src', iframe.src);
                  iframe.removeAttribute('src');
                }
              }
            }
            this.removeCloseClassFromConsentButton();
          },
          openModal() {
            this.modalActive = true;
            this.htmlElement.classList.add('is-clipped');
            this.$nextTick(() => {
              this.removeCloseClassFromConsentButton();
            });
          },
          closeModal() {
            this.modalActive = false;
            this.htmlElement.classList.remove('is-clipped');
            if (this.isVideo) {
              this.$refs.modalContent
                .querySelector('iframe')
                .contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
            }
          },
          internallyCloseModal() {
            this.closeModal();
            this.$emit('closeModal');
          },
          escCloseModal(event) {
            if (event.keyCode === 27) {
              this.internallyCloseModal();
            }
          },
        },
      });

      app.mount(`#${element.id}`);
    });
  }

  initConsentModals(pinia);
}
